import { Box, Typography } from "@mui/material"
import React, { Component, ErrorInfo, ReactNode } from "react"
import { Colors } from "../../types"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class SubscriptionErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      "Subscription Error Boundary caught an error:",
      error,
      errorInfo,
    )
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            gap: 2,
            padding: 3,
          }}
        >
          <Typography variant="h6" color="error">
            Subscription Error
          </Typography>
          <Typography variant="body1" textAlign="center">
            Something went wrong while processing your subscription.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: Colors.purple900,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => (window.location.href = "/")}
          >
            Return to Home
          </Typography>
        </Box>
      )
    }

    return this.props.children
  }
}
